import { cn } from "@tellescope/ui";
import type { SpacerBlock as SpacerBlockType } from "../../../shared/schema";

interface SpacerBlockProps {
  size: SpacerBlockType["props"]["size"];
}

const sizeStyles: Record<SpacerBlockType["props"]["size"], string> = {
  sm: "h-2",
  md: "h-4",
  lg: "h-8",
  xl: "h-12",
};

export const SpacerBlock: React.FC<SpacerBlockProps> = ({ size = "md" }) => {
  return <div className={cn(sizeStyles[size])} aria-hidden="true" />;
};
